package one.healthium.healthKit.di

import one.healthium.healthKit.data.HealthKitHelper
import one.healthium.healthKit.data.HealthKitManager
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

actual fun healthKitPlatformModule() = module {
    singleOf(::HealthKitHelper)
    singleOf(::HealthKitManager)
}